import { useQuery } from '@tanstack/react-query';

import { apiClient } from 'api/ApiClient';
import { useGetProfile } from 'entities/user/api/useGetProfile';
import { useAuth } from 'shared/lib/auth/useAuth';

import type { FeaturesResponse } from './common';

export const useFeatures = (enabled = true) => {
  const { isAuthReady } = useAuth();

  return useQuery({
    queryKey: ['getFeatures'],
    queryFn: () => apiClient.getAnalyticsSource<FeaturesResponse>('features', {}),
    retry: false,
    enabled: isAuthReady,
  });
};

export const useHasAllUsersFeature = () => {
  const { data: features } = useFeatures();
  const { data: profile } = useGetProfile();

  return !new Set(features?.flags?.old_users_companies).has(profile?.company?.id ?? '');
};
